import clsx from 'clsx';
import React from 'react';

import s from './SideOverlayContainer.module.less';

export const MessengerOverlayMfeShell: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div {...rest} className={clsx(s.messengerOverlayMfeShell, className)}>
    {children}
  </div>
);

export const ContentContainer = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, children, ...rest }, ref) => (
    <div {...rest} ref={ref} className={clsx(s.contentContainer, className)}>
      {children}
    </div>
  ),
);

ContentContainer.displayName = 'ContentContainer';

export const HeaderControlsBlock: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div {...rest} className={clsx(s.headerControlsBlock, className)}>
    {children}
  </div>
);

interface IconProps extends React.HTMLAttributes<HTMLDivElement> {
  size: string;
}

const makeIcon = (iconClassName: string) => {
  const Icon: React.FC<IconProps> = ({ className, size, style, ...rest }) => (
    <div
      {...rest}
      className={clsx(iconClassName, className)}
      style={{ '--icon-size': size, ...style } as React.CSSProperties}
    />
  );

  return Icon;
};

export const CrossIcon = makeIcon(s.crossIcon);
CrossIcon.displayName = 'CrossIcon';

export const SwapIcon = makeIcon(s.swapIcon);
SwapIcon.displayName = 'SwapIcon';

export const MessengerLayoutExpandIcon = makeIcon(s.messengerLayoutExpandIcon);
MessengerLayoutExpandIcon.displayName = 'MessengerLayoutExpandIcon';

export const MessengerLayoutCollapseIcon = makeIcon(s.messengerLayoutCollapseIcon);
MessengerLayoutCollapseIcon.displayName = 'MessengerLayoutCollapseIcon';
